import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 53.93 53.93",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#fff;}" }) }), /* @__PURE__ */ _jsx("path", {
		className: "cls-1",
		d: "M18,0,0,18v36H36l18-18V0ZM42,36H30.11A12.13,12.13,0,0,1,18,23.82V12H42Z"
	})]
});
export default SvgLogoSymbol;
